import { render, staticRenderFns } from "./HelpPagesFormComponent.vue?vue&type=template&id=00a51805&scoped=true"
import script from "./HelpPagesFormComponent.vue?vue&type=script&lang=js"
export * from "./HelpPagesFormComponent.vue?vue&type=script&lang=js"
import style0 from "./HelpPagesFormComponent.vue?vue&type=style&index=0&id=00a51805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a51805",
  null
  
)

export default component.exports